export default "__VITE_ASSET__Dqsiswte__"